// benefit  banner js//
function initBenefitBarSlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--benefit-initialized')) return;

  const splide = new Splide(slider, {
    type: 'loop',
    autoWidth: true,
    gap: '45px',
    pagination: false,
    arrows: false,
    drag: false,
    clones: 10,
    autoScroll: {
      speed: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  });

  splide.mount(window.splide.Extensions);

  slider.classList.add('splide--benefit-initialized');
}

function autoInitBenefitBars(scope = document) {
  scope.querySelectorAll('.benefit-bar-splide').forEach((slider) => {
    initBenefitBarSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  autoInitBenefitBars();
});

document.addEventListener('shopify:section:load', (event) => {
  autoInitBenefitBars(event.target);
});

document.addEventListener('shopify:section:select', (event) => {
  autoInitBenefitBars(event.target);
});

// benefit bar js end //


// testimonial js start //
function initTestimonialSlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--testimonial-initialized')) return;

  const splide = new Splide(slider, {
    type: 'slide',
    perPage: 3,
    perMove: 1,
    gap: '24px',
    pagination: false,
    arrows: true,
    drag: true,

    breakpoints: {
      1270: {
        perPage: 3,
        gap: '15px',
      },

      989: {
        perPage: 2,
        gap: '15px',
      },

      575: {
        perPage: 1,
        perMove: 1,
        gap: '10px',
      },

      359: {
        perPage: 1,
        perMove: 1,
      },
    },
  });

  splide.mount();

  slider.classList.add('splide--testimonial-initialized');
}

function autoInitTestimonialSliders(scope = document) {
  scope.querySelectorAll('.testimonials-splide').forEach((slider) => {
    initTestimonialSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => autoInitTestimonialSliders());

document.addEventListener('shopify:section:load', (event) => {
  autoInitTestimonialSliders(event.target);
});

document.addEventListener('shopify:section:select', (event) => {
  autoInitTestimonialSliders(event.target);
});

// testimonial js end //


function initFeaturedSlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--featured-initialized')) return;

  const splide = new Splide(slider, {
    type: 'loop',
    perPage: 3,
    perMove: 1,
    gap: '20px',
    pagination: false,
    arrows: true,
    drag: true,

    breakpoints: {
      1600: {
        perPage: 3
      },

      1199: {
        perPage: 3
      },

      1024: {
        perPage: 3
      },

      768: {
        perPage: 2
      },

      575: {
        perPage: 1,
        perMove: 1
      }
    }
  });

  const bar = slider.querySelector('.my-carousel-progress-bar');

  splide.on('mounted move', function () {
    if (!bar) return;

    const end = splide.Components.Controller.getEnd() + 1;
    const rate = Math.min((splide.index + 1) / end, 1);

    bar.style.width = `${rate * 100}%`;
  });

  splide.mount();

  slider.classList.add('splide--featured-initialized');
}

function autoInitSliders(scope = document) {
  scope.querySelectorAll('.fps-splide').forEach((slider) => {
    initFeaturedSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  autoInitSliders();
});

document.addEventListener('shopify:section:load', (event) => {
  autoInitSliders(event.target);
});

document.addEventListener('shopify:section:select', (event) => {
  autoInitSliders(event.target);
});


document.addEventListener('click', function (event) {
  const swatch = event.target.closest('.color-swatch');

  if (!swatch) return;

  const card = swatch.closest('.card-wrapper');

  if (!card) return;

  const image = card.querySelector('.card__media img');
  const newImage = swatch.dataset.image;

  if (image && newImage) {
    image.src = newImage;
    image.removeAttribute('srcset');
  }

  card.querySelectorAll('.color-swatch').forEach(function (item) {
    item.classList.remove('active');
  });

  swatch.classList.add('active');

  const variantId = swatch.dataset.variantId;
  const variantInput = card.querySelector('.product-variant-id');

  if (variantInput && variantId) {
    variantInput.value = variantId;
  }

  const addButton = card.querySelector('.quick-add__submit');
  const available = swatch.dataset.available === 'true';

  if (addButton) {
    addButton.disabled = !available;
  }

});


function initRelatedProductsSplide(scope = document) {
  scope.querySelectorAll('product-recommendations').forEach((section) => {
    const splideEl = section.querySelector('.products-available');

    if (!splideEl) return;
    if (splideEl.classList.contains('splide--related-initialized')) return;

    const splide = new Splide(splideEl, {
      type: 'slide',
      perPage: 4,
      gap: '20px',
      arrows: true,
      pagination: false,
      drag: true,
      breakpoints: {
        1200: {
          perPage: 3
        },
        990: {
          perPage: 2
        },
        750: {
          perPage: 1,
          padding: {
            right: '0px',
            left: '0px'
          }
        }
      }
    });

    splide.mount();
    splideEl.classList.add('splide--related-initialized');
  });
}

/* Auto Init */
function autoInitRelatedProducts(scope = document) {
  initRelatedProductsSplide(scope);
}

/* Initial Load */
document.addEventListener('DOMContentLoaded', () => {
  autoInitRelatedProducts();

  document.querySelectorAll('product-recommendations').forEach((el) => {
    relatedObserver.observe(el, {
      childList: true,
      subtree: true
    });
  });
});

/* Shopify Theme Editor */
document.addEventListener('shopify:section:load', (e) => {
  autoInitRelatedProducts(e.target);
});

document.addEventListener('shopify:section:select', (e) => {
  autoInitRelatedProducts(e.target);
});

/* Observe AJAX Load */
const relatedObserver = new MutationObserver(() => {
  autoInitRelatedProducts();
});
